<div class="e-input-group" [attr.data-test-id]="'labOrderLookupInputGroup'">
	<input #labOrderInput class="e-input" [(ngModel)]="labOrderName" [disabled]="disabled" (keydown.enter)="openLookupModal()"/>
	@if (!disabled) {
		<span class="e-input-group-icon fa fa-search" (click)="openLookupModal()"></span>
	}
</div>
